
import React from "react";
// react library for routing
import {Route, Switch} from "react-router-dom";
// core components
import AdminNavbar from "../components/Navbars/AdminNavbar.jsx";
import AdminFooter from "../components/Footers/AdminFooter.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";

import adminRoutes from "../routes/newAdminRoutes";
import 'react-image-lightbox/style.css';
import DownloadUtil from "../util/downloadUtil";
import AdminService from "../services/adminService";
import subscribedUserRoutes from "../routes/subscribedUserRoutes";
import { getNewUiUrl } from "../utils/urlHelper";

class Admin extends React.Component {
  state = {
    sidenavOpen: true,
    imgSrc:"",
    routes: adminRoutes,
  };

  componentDidMount() {
    // this.toggleSidenav();
    let userId = localStorage.getItem("userId")
    let brandLogoUID = localStorage.getItem("brandLogoUID");
    this.getUserRoutes();
    AdminService.fetch(userId).then(resp => {
      if(resp.data.brandLogoUID === null){
        this.setState({imgSrc: require("assets/img/brand/xareLogo_transparent.png")})
      } else {
        this.setState({imgSrc:DownloadUtil.generateUrl(resp.data.brandLogoUID)})
      }
      if (!sessionStorage.getItem('reloaded')) {
        sessionStorage.setItem('reloaded', 'true');
        window.location.reload();
      }
    })
  }

  getUserRoutes = () => {
    let allowedSaasRoles = ["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]
    const storedRoles = JSON.parse(localStorage.getItem('CLASHMATE_ROLE_LIST')) || [];
    // Check if any of the allowedRoles are present in storedRoles
    const hasSaasUserRole = allowedSaasRoles.some(role => storedRoles.includes(role));

     hasSaasUserRole ? this.setState({routes: subscribedUserRoutes}) : this.setState({routes: adminRoutes});

  }

  componentDidUpdate(e) {
    if (e.history.pathname !== e.location.pathname) {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainContent.scrollTop = 0;
    }
  }
  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.layout === "/crm") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else if (prop.layout === "/user") {
        return (
            <Route
                path={prop.layout + prop.path}
                component={prop.component}
                key={key}
            />
        );
      } else {
        return null;
      }
    });
  };
  getBrandText = path => {
    for (let i = 0; i < this.state.routes.length; i++) {
      if (
        this.props.location.pathname.indexOf(
          this.state.routes[i].layout + this.state.routes[i].path
        ) !== -1
      ) {
        return this.state.routes[i].name;
      }
    }
    return "Brand";
  };
  // toggles collapse between mini sidenav and normal
  toggleSidenav = e => {
    if (document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-pinned");
      document.body.classList.add("g-sidenav-hidden");
    } else {
      document.body.classList.add("g-sidenav-pinned");
      document.body.classList.remove("g-sidenav-hidden");
    }
    this.setState({
      sidenavOpen: !this.state.sidenavOpen
    });
  };
  getNavbarTheme = () => {
    return this.props.location.pathname.indexOf("admin/dashboard") === -1
      ? "dark"
      : "light";
  };
  render() {
    return (
      <>
        <Sidebar
          {...this.props}
          routes={this.state.routes}
          toggleSidenav={this.toggleSidenav}
          sidenavOpen={this.state.sidenavOpen}
          logo={{
              outterLink: getNewUiUrl() + "/",
              imgSrc: this.state.imgSrc,
              imgAlt: "XareGrowth"
          }}
        />
        <div
          className="main-content"
          ref="mainContent"
          onClick={this.closeSidenav}
        >
          <AdminNavbar
            {...this.props}
            theme={this.getNavbarTheme()}
            toggleSidenav={this.toggleSidenav}
            sidenavOpen={this.state.sidenavOpen}
            brandText={this.getBrandText(this.props.location.pathname)}
          />
          <Switch>{this.getRoutes(this.state.routes)}</Switch>
          <AdminFooter/>
        </div>
        {this.state.sidenavOpen ? (
          <div className="backdrop d-xl-none" onClick={this.toggleSidenav} />
        ) : null}
      </>
    );
  }
}

export default Admin;
